/** ONE Conversations — full workspace page.
 *  Reachable at /conversations from the MORE popover.  Simple 2-pane layout:
 *  list on the left, thread on the right.  For deep filtering / mentions inbox.
 */
import { useEffect, useState } from "react";
import { ChatDrawer } from "@/components/app/ChatDrawer";

export default function Conversations() {
  const [openDrawer, setOpenDrawer] = useState(true);
  // We reuse ChatDrawer but render it fixed as a full page:
  useEffect(() => { document.title = "ONE Conversations · SUNTRONIX ONE"; }, []);
  return (
    <div className="min-h-[70vh]" data-testid="conversations-page">
      <div className="st-page-header mb-4">
        <div>
          <div className="text-[11px] uppercase tracking-[0.18em] text-[color:var(--st-text-muted)]">Collaboration</div>
          <h1 className="st-page-title">ONE Conversations</h1>
          <div className="st-page-context">Contextual chat that lives with the work — Asset, Employee, Request, Shipment, Invoice.</div>
        </div>
        <button onClick={() => setOpenDrawer(true)} data-testid="conv-open-drawer"
          className="st-btn st-btn-primary">Open drawer</button>
      </div>
      <div className="st-panel p-6 text-[13px] text-[color:var(--st-text-muted)]">
        <p>
          Use the <b>chat icon in the header</b> at any time to open the collaboration drawer without leaving the current page.
          Every conversation carries a strict visibility label — <b>Internal</b>, <b>Customer&nbsp;shared</b> or <b>Partner&nbsp;shared</b> —
          enforced on the server so customers can never see internal notes.
        </p>
        <ul className="mt-4 list-disc pl-5 space-y-1">
          <li>Attach conversations to any Asset, Employee, Request, Shipment, Invoice, Contract or Programme.</li>
          <li>Mentions, edit history and soft delete are captured for audit.</li>
          <li>Deep features (WhatsApp / Teams adapters, translation, AI summary, presence, read receipts, legal-hold, retention config) are on the roadmap and not enabled yet.</li>
        </ul>
      </div>
      {openDrawer && <ChatDrawer onClose={() => setOpenDrawer(false)} />}
    </div>
  );
}
